<template>
  <div class="vote">
    <NoData
      v-if="poll == null"
      :title="$t('nodatakeys.polls.nodatatitle')"
      :description="$t('nodatakeys.polls.nodatadesc')"
      anim="holacon-polls-lottie"
      :loading="loading"
    />

    <div class="answers" v-if="vote == null && poll != null && showRates != true && poll.title != null">
      <h3>{{ poll.title }}</h3>
      
      <div v-for="(i, key) in poll.answers" :key="key" class="answer" @click="answer = i" :class="i == answer ? 'selected' : ''">
        <div style="width: 50px; height: 50px; display: flex; align-items: center; justify-content: center">
          <i v-if="i == answer" class="icon icon-checkmark" :style="'color: ' + $store.state.event.event.color"/>
          <i v-if="i != answer" class="icon icon-checkmark2" />
        </div>
        <span>{{ i }}</span>
      </div>

      <md-button
        class="md-primary md-raised"
        style=" margin: 0px; width: 100%; margin-top: 20px; border-radius: 8px;"
        :style="'background-color: ' + $store.state.event.event.color + ';'"
        @click="save">{{ $t("vote.dovote") }}</md-button>
    </div>

    <div class="rates" v-if="vote != null || showRates == true && poll != null">
      <h3 style="display: block; width: 100%; text-align: center">{{ poll.title }}</h3>
      <div class="rate" v-for="i in poll.answerRates" :key="i.answer">
        <div class="title">{{ i.answer }}</div>
        <div class="rate-value">{{ i.rate }}%</div>
        <div class="rate-bar" :style="'transition: 1s; width: ' + i.rate + '%; background-color: ' + $store.state.event.event.color + '60;'"></div>
      </div>
    </div>

    <md-snackbar class="warning" :md-position="'center'" :md-duration="4000" :md-active.sync="error" md-persistent>
      <i class="fa fa-exclamation-triangle"></i><span>{{ $t("poll.select_answer") }}</span>
    </md-snackbar>

    <md-snackbar class="warning" :md-position="'center'" :md-duration="4000" :md-active.sync="errorVote" md-persistent>
      <i class="fa fa-exclamation-triangle"></i><span>{{ voteMessage }}</span>
    </md-snackbar>

  </div>
</template>

<script>
import axios from "axios";
import NoData from "../../modules/NoData";
export default {
  name: "Vote",
  components: { NoData },
  props: ["showRates"],
  data() {
    return {
      loading: true,
      vote: null,
      poll: null,
      answer: null,
      error: false,
      interval: null,
      errorVote: false,
      voteMessage: null
    };
  },
  async created() {
    var response = await axios.post("participant/checkpoll");
    this.vote = response.data.data.vote;
    this.poll = response.data.data.poll;
    this.loading = false;

    if (this.poll != null) {
      this.interval = setInterval(async () => {
        var response = await axios.post("participant/checkpoll");
        this.vote = response.data.data.vote;
        this.poll = response.data.data.poll;
      }, 5000);
    }

    this.$root.$on("voteStatusChanged2", a => {
      this.getData();
    });
  },
  methods: {
    async getData() {
      var response = await axios.post("participant/checkpoll");
      this.vote = response.data.data.vote;
      this.poll = response.data.data.poll;

      if (this.vote != null) {
        clearInterval(this.interval);
        this.interval = null;
        this.interval = setInterval(async () => {
          var response = await axios.post("participant/checkpoll");
          this.vote = response.data.data.vote;
          this.poll = response.data.data.poll;
        }, 5000);
      }
    },
    async save() {
      if (this.answer == null) {
        this.error = true;
        return;
      }

      await axios
        .post("participant/dovote", {
          answer: this.answer
        })
        .then(res => {
          if (res.data.hasError == true) {
            this.voteMessage = res.data.message;
            this.errorVote = true;
          }
        });
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
    this.interval = null;
    this.$root.$off("voteStatusChanged");
  }
};
</script>

<style lang="less" scoped>
.answers {
  padding: 10px 15px;
  box-sizing: border-box;
  h3 {
    width: 100%;
    display: block;
    text-align: center;
  }
  .answer {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid whitesmoke;

    &.selected {
      background: whitesmoke;
    }
  }

  .answer:last-child {
    border: none;
    margin-bottom: 20px;
  }
}

.rates {
  padding: 10px;

  .rate {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: relative;
    min-height: 45px;
    overflow: hidden;
    margin-top: 10px;
    background-color: whitesmoke;
    border: 0.5px solid #D6D9D9;
    box-sizing: border-box;
    padding: 5px 10px;
    border-radius: 8px;

    .title {
      display: flex;
      flex: 1;
      z-index: 9;
      position: relative;
      color: #292f3b;
      font-weight: 500;
      font-size: 14px;
    }

    .rate-value {
      z-index: 9;
      color: #292f3b;
      font-weight: 600;
      font-size: 16px;
      position: relative;
    }

    .rate-bar {
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/event/Vote.vue